import React from "react";
import "./Delete_Confirm_Modal.css";
import { Button, Modal } from "react-bootstrap";
import Delete_Lottie from "./Delete_Lottie/Delete_Lottie";

function Delete_Confirm_Modal(props) {
  const { message, subMessage } = props; // Extracting 'message' prop
  return (
    <>
      <div className="Delete_Modal_sec">
        <Modal
          className="Delete_Modal"
          {...props}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton> Do you want to delete this?</Modal.Header>
          <Modal.Body>
            <div className="lottie-holder text text-danger">
             
            </div>
            <div className="text-center">
              <Button className="btn btn-danger me-4" onClick={props.onHide}>
                No
              </Button>
              <Button
                className="btn btn-success"
                onClick={() => props.handleDelete(props.show)}
              >
                Yes
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Delete_Confirm_Modal;
